import { patchCommercialOutboundApprove, patchResearchOutboundApprove, } from "@erp/shared/api/generated/wrappers/outbound";
import { usePageInfo } from "@erp/shared/composables/usePageInfo";
import { useState } from "@erp/shared/composables/useState";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
import { queries } from "@erp/shared/queries";
import { useInvalidateQueries } from "@erp/shared/composables";
import { showAlert } from "@erp/shared/utils/dialog";
export const useOutboundSearchAction = () => {
    const { isCommercialPage } = usePageInfo();
    const { invalidateQueries } = useInvalidateQueries();
    const [readParams, setReadParams] = useState(null);
    const [outboundId, setOutboundId] = useState(null);
    const readOutboundConfirmQueryOptions = computed(() => {
        return {
            ...queries.outbound.confirm(isCommercialPage.value, readParams.value ?? undefined),
        };
    });
    const readOutboundConfirm = useQuery(readOutboundConfirmQueryOptions);
    const readOutboundProductQueryOptions = computed(() => {
        const outboundIdValue = outboundId.value ?? 0;
        return {
            ...queries.outbound.products(isCommercialPage.value, outboundIdValue),
            enabled: computed(() => !!outboundId.value),
        };
    });
    const readOutboundProduct = useQuery(readOutboundProductQueryOptions);
    const updateOutboundApproval = useMutation({
        mutationFn: async ({ pathParams, body }) => {
            return isCommercialPage.value
                ? await patchCommercialOutboundApprove({
                    pathParams,
                    body,
                })
                : await patchResearchOutboundApprove({ pathParams, body });
        },
        onSuccess: async () => {
            await invalidateQueries([queries.outbound._def, queries.project._def]);
            readOutboundConfirm.refetch();
        },
        onError: () => showAlert("출고 승인 처리에 실패했습니다."),
    });
    return {
        readOutboundConfirm,
        readOutboundProduct,
        updateOutboundApproval,
        setOutboundId,
        setReadParams,
    };
};
